import { DataBean } from "../DataBean";

export class ResourceResourceCostCatalog extends DataBean {


    public async getResourceResourceCostCatalog(idLabour:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getResourceResourceCostCatalog_Number", [idLabour]);
    }

}